var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reload-effect',{attrs:{"vNode":_vm.innerValue,"effect":_vm.reloadEffect},on:{"effect-end":_vm.handleEffectEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }